

























import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import Enumerable from "linq";

@Component({
  components: {
  }
})

export default class AssemblyVersionViewer extends Mixins() {
  
  data(): any {
    return {
      assemblyname: null as string,
      assemblyver: null as string,
      assemblyfilever: null as string,
      assemblycompany: null as string,
      assemblycopyright: null as string,
    };
  }
  assemblyname: string;
  assemblyver: string;
  assemblyfilever: string;
  assemblycompany: string;
  assemblycopyright: string;

  mounted() {
    this.assemblyConfiguration();
  }
  
  async assemblyConfiguration(): Promise<void> {
    const repository = DomainRegistry.developer.getConfigurationRepository();
    const source = await repository.getAssemblyVer();
    this.$nextTick(() => {
      this.infomations(source);
    });
  }

  infomations(source: string): void {
    this.assemblyver = this.Settingtext(source, "ver:");
    this.assemblyname = this.Settingtext(source, "name:");
    this.assemblyfilever = this.Settingtext(source, "fver:");
    this.assemblycompany = this.Settingtext(source, "company:");
    this.assemblycopyright = this.Settingtext(source, "copyright:");
  }

  Settingtext(source: string , strkey: string): string {
    const ret = (Enumerable.from(source.split(",")).
    where(s => s.startsWith(strkey)).firstOrDefault()); 
    return  ret ? ret.substring(ret.lastIndexOf(":") + 1) : "";
  }
}
